import { CustomerTransactionInterface } from "@/interface/customer/transaction";
import {
  CustomerTransactionType,
  TransactionCreatorType,
  TransactionCustomerType,
  TransactionTenderType,
} from "@/types/customer/transaction.type";

import { PriceMoney, SummaryItem, Variation } from "@/modules/location";
import { PriceInterface, SummaryItemInterface, VariationInterface } from "@/interface/business/item.interface";
import { OrderDeliveryInterface } from "@/interface/business/order.interface";
import { ExternalFees } from "@/modules/customer/transactions/external-fees";

export class CustomerTransaction implements CustomerTransactionInterface {
  id: string = "";
  location_id: string = "";
  receipt_id: string = "";
  serial_number: string = "";
  dining_option: string = "";
  order_option?: string = "";
  creation_time: string = "";
  customer_count: number = 0;
  position?: any = null;
  discount_money: PriceInterface;
  additive_tax_money: PriceInterface;
  inclusive_tax_money: PriceInterface;
  refunded_money: PriceInterface;
  tax_money: PriceInterface;
  tip_money: PriceInterface;
  received_money: PriceInterface;
  total_collected_money: PriceInterface;
  extra_charges_money: PriceInterface;
  creator: TransactionCreatorType;
  customer: TransactionCustomerType;
  delivery?: OrderDeliveryInterface;
  drawer?: any;
  loyalty?: any;
  tab?: any;
  tenders: Array<TransactionTenderType>;
  taxes: Array<any>;
  extra_charges: Array<any>;
  external_fees: Array<any>;
  itemization: Array<SummaryItemInterface>;

  constructor(data: CustomerTransactionType) {
    Object.assign(this, data);

    this.creator = data.creator;
    this.customer = data.customer;
    this.tenders = data.tenders;

    this.tenders = data.tenders.map((item) => {
      item.total_money = new PriceMoney({
        amount: item?.total_money?.amount || 0,
      });

      return item;
    });

    this.taxes = data.taxes;
    this.extra_charges = data.extra_charges;
    this.external_fees = data.external_fees?.map((eFees) => new ExternalFees(eFees));
    this.itemization = data.itemization.map((item) => {
      return new SummaryItem({
        id: item.id,
        name: item.name,
        local_name: item.local_name,
        quantity: item.quantity,
        total_money: item?.total_money,
        variations: [],
        variation: item?.variation ? <VariationInterface>new Variation(item.variation) : undefined,
      });
    });

    this.discount_money = new PriceMoney({
      amount: data?.discount_money?.amount ?? 0,
      currency: data?.discount_money?.currency,
    });

    this.additive_tax_money = new PriceMoney({
      amount: data?.additive_tax_money?.amount ?? 0,
      currency: data?.additive_tax_money?.currency,
    });

    this.inclusive_tax_money = new PriceMoney({
      amount: data?.inclusive_tax_money?.amount ?? 0,
      currency: data?.inclusive_tax_money?.currency,
    });

    this.refunded_money = new PriceMoney({
      amount: data?.refunded_money?.amount ?? 0,
      currency: data?.refunded_money?.currency,
    });

    this.tax_money = new PriceMoney({
      amount: data?.tax_money?.amount ?? 0,
      currency: data?.tax_money?.currency,
    });

    this.tip_money = new PriceMoney({
      amount: data?.tip_money?.amount ?? 0,
      currency: data?.tip_money?.currency,
    });

    this.received_money = new PriceMoney({
      amount: data?.received_money?.amount ?? 0,
      currency: data?.received_money?.currency,
    });

    this.total_collected_money = new PriceMoney({
      amount: data?.total_collected_money?.amount ?? 0,
      currency: data?.total_collected_money?.currency,
    });

    this.extra_charges_money = new PriceMoney({
      amount: data?.extra_charges_money?.amount ?? 0,
      currency: data?.extra_charges_money?.currency,
    });
  }

  /**
   * Create at date time
   * @return {string}
   */
  createdAt() {
    return window.moment(this.creation_time).format("YYYY-MMM-DD hh:mm A");
  }
}
